<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Fasting for Miracles</title>
<section epub:type="acknowledgments">
<p class="ct1"><span epub:type="pagebreak" id="page_xii" title="xii"><a href="#/contenttoc#t1" id="c1">ACKNOWLEDGMENTS</a></span></p>
<p class="tx1">I <span class="small">WOULD LIKE</span> to acknowledge the following people who have made this book possible.</p>
<p class="tx">Lori DeAngelo and Lisa Haines, thank you for your friendship and dedication to helping me edit this book. You have always been there for me.</p>
<p class="tx">Diane Campos, thank you for your eye for detail and passion and love for the Lord Jesus Christ. You truly are a gift.</p>
<p class="tx">Phil Hotsenpiller, my wonderful husband, you have been my greatest encourager. Thank you for always challenging me.</p>
<p class="tx">Influence Church, you are the reason I am where I am today. My prayer and fasting life have grown because of you.</p>
<p class="tx">Charisma House, it has been an honor and a privilege to work with you. Your professionalism and commitment to this project have been a blessing to me.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?509ea45a